import React, { useEffect } from 'react'
import { string } from 'prop-types'
import styles from './BrandContact.module.scss'
import Container from '@/component/Primitive/Container'
import Type from '@/component/Primitive/Type'
import ChevronTitle from '@/component/Primitive/ChevronTitle'
import OffsetAnchor from '@/component/Primitive/OffsetAnchor'

import { createInlineForm } from '@formcrafts/embed'

const BrandContact = ({ retUrl, brandName }) => {
  useEffect(() => {
    createInlineForm({
      form: 'e8131e61',
      target: document.getElementById('formcrafts'),
      seamless: true,
      redirectWithin: false,
      values: {
        field17: retUrl,
        field16: brandName
      }
    })
  })

  return (
    <>
      <OffsetAnchor identifier="media-kit-download" />
      <div className={styles.BrandContact}>
        <Container size="large" className={styles.Container} gutter center>
          <ChevronTitle className={styles.Title} title="Get in touch" />
          <Type size={['body3', 'body1']} className={styles.Description}>
            Hi there! If you’d like to get in touch with any comments or
            queries, or to become part of the story, fill in the following
            information
          </Type>

          <div id="formcrafts" className={styles.Formcrafts} />
        </Container>
      </div>
    </>
  )
}

BrandContact.propTypes = {
  retUrl: string,
  brandName: string
}

export default BrandContact
